import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Modal, Select } from '@weezevent/nacre';

import Styles from '../attendees/attendees.module.css';

export default function SendMailWithStatusModal({ open, setOpenModal }) {
    const { t } = useTranslation();

    return (
        <Modal
            size="large"
            open={open}
            onClose={() => setOpenModal(false)}
            title={t('ticket.moderation.attendees.sendMailModalTitle')}
            subtitle={t('ticket.moderation.attendees.sendMailModalSubtitle')}
            allowExternalClosing={false}
            cancelButton={<Button label={t('ticket.common.action.back')} onClick={() => setOpenModal(false)} />}
            submitButton={<Button primary label={t('ticket.common.action.send')} />}
        >
            <label className={Styles['attendees-mail-modal-label']}>{t('ticket.moderation.attendees.sendMailModalLabel')}</label>
            <Select
                options={[
                    {
                        text: 'transition1',
                        value: 'transition1'
                    },
                    {
                        text: 'transition2',
                        value: 'transition2'
                    },
                    {
                        label: 'transition3',
                        text: 'transition3'
                    }
                ]}
                placeholder={t('ticket.moderation.attendees.sendMailModalPlaceholder')}
                useNew
            />
        </Modal>
    );
}

SendMailWithStatusModal.propTypes = {};
